<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Tax Settings</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <!--<li class="breadcrumb-item">Employee</li>-->
          <li class="breadcrumb-item active" aria-current="page">Tax Settings</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <ul class="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <ng-container *appHasPermission="makePermissions(tabs[i], ['view'])">
        <li class="nav-item">
          <button
            [ngClass]="{ 'nav-link': true, active: activeChild === tab }"
            (click)="renderChild(tab)"
          >
            <i class="ti ti-settings me-2"></i>{{ tab }}
          </button>
        </li>
      </ng-container>
    </ng-container>
  </ul>

  <div [ngSwitch]="activeChild">
    <ng-container *ngSwitchCase="tabs[0]">
      <app-tax-slabs *appHasPermission="makePermissions(tabs[0], ['view'])"></app-tax-slabs>
    </ng-container>

    <ng-container *ngSwitchCase="tabs[1]">
      <app-tax-rules *appHasPermission="makePermissions(tabs[1], ['view'])"></app-tax-rules>
    </ng-container>
  </div>
</div>
